//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { PadlockUnlockedMediumSVG } from './svg'

interface PadlockUnlockedMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const PadlockUnlockedMediumIcon: React.FC<PadlockUnlockedMediumIconProps> = forwardRef<
  PadlockUnlockedMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={PadlockUnlockedMediumSVG}
    sx={sx}
  />
))
